import { useRouter } from 'next/router';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { isPhoneVerificationPromptRouteEligible } from '@/shared/features/phone-verification/utils';
import { usePhoneVerificationBannerModal } from '../hooks';
export const PhoneVerificationBannerModalGate = () => {
  const router = useRouter();
  const isInExternalPlatform = useIsInExternalPlatform();
  const isEnabled = isPhoneVerificationPromptRouteEligible({
    isInExternalPlatform,
    pathname: router.pathname
  });
  usePhoneVerificationBannerModal({
    enabled: isEnabled
  });
  return null;
};